import React, { useState } from "react";
import { IResponsePost } from "../../../Interfaces/base/IResponse";
import { useBoolean } from "@fluentui/react-hooks";
import { ICrearArea, InitialCrearArea } from "../../../Interfaces/IPERC/IArea";
import IPERCService from "../../../services/IPERCService";

export const useCrearArea = (load) => {
  const [response, setResponse] = useState<IResponsePost>(null!);
  const [isSend, { setTrue: onEnviar, setFalse: onCancelar }] =
    useBoolean(false);

  const [modelrequestCrear, setModelRequestCrear] =
    useState<ICrearArea>(InitialCrearArea);

  const ocultarMensaje = () => {
    setResponse(null!);
  };
  const onChangeTextField = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    if (event !== undefined) {
      if (newValue !== undefined) {
        setModelRequestCrear({
          nombre: newValue,
        });
      }
    }
  };

  const handleCrearNuevaArea = () => {
    ocultarMensaje();
    onEnviar();
    IPERCService.agregarArea(modelrequestCrear)
      .then((res) => {
        if (res.status === 200) {
          setResponse({
            codigoMensaje: res.data.codigoMensaje,
            mensaje: res.data.mensaje,
          });
          onCancelar();
          load();
        }
      })
      .catch((err) => {
        onCancelar();
      });
  };
  return {
    response,
    isSend,
    ocultarMensaje,
    modelrequestCrear,
    onChangeTextField,
    handleCrearNuevaArea,
  };
};
